import actionsConfig from './actionsConfig';
import nameConfig from './nameConfig';

export default (labels, tab) => [nameConfig(labels), actionsConfig(labels, tab)];
